const numberFormatter = (number) => {
  try {
    return number.toLocaleString('pl-PL', {minimumFractionDigits: 2, maximumFractionDigits: 2})
  } catch (e) {
  }
}

const GlobalMixins = {
  methods: {
    numberFormatter (number) {
      return numberFormatter(number)
    },
    getPermission (perm) {
      if (JSON.parse(localStorage.getItem('userDataOptions')) !== null && typeof JSON.parse(localStorage.getItem('userDataOptions')).options[perm] !== 'undefined') {
        return JSON.parse(localStorage.getItem('userDataOptions')).options[perm]
      }
      return false
    }
  },
  filters: {
    filter (number) {
      return numberFormatter(number)
    }
  }
}

export default GlobalMixins



// WEBPACK FOOTER //
// ./src/helpers/GlobalMixins.js